export default __webpack_public_path__ + "static/media/oleo.0b707441.svg";